/**
 * Loading / empty / error shells. Every teacher route uses these so the
 * three states have one accessible look-and-feel instead of drifting per
 * page.
 */

import type { ApiError } from '../api/types';

export function LoadingState({ label = 'Loading…' }: { label?: string }) {
  return (
    <div
      className="state state--loading"
      role="status"
      aria-live="polite"
      data-testid="state-loading"
    >
      <span className="state__spinner" aria-hidden="true" />
      <p>{label}</p>
    </div>
  );
}

export function EmptyState({
  title,
  description,
}: {
  title: string;
  description?: string;
}) {
  return (
    <div className="state state--empty" data-testid="state-empty">
      <h3>{title}</h3>
      {description ? <p>{description}</p> : null}
    </div>
  );
}

export function ErrorState({
  error,
  onRetry,
}: {
  error: ApiError;
  onRetry?: () => void;
}) {
  return (
    <div
      className="state state--error"
      role="alert"
      data-testid="state-error"
    >
      <h3>Something went wrong</h3>
      <p>
        <code>{error.code}</code> — {error.message}
      </p>
      {onRetry ? (
        <button type="button" className="btn" onClick={onRetry}>
          Retry
        </button>
      ) : null}
    </div>
  );
}
